export const footerModalOverlayStyle = ({
  zIndex = 3500,
  centered = false
} = {}) => ({
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.4)',
  zIndex,
  ...(centered
    ? {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    : {})
})

export const footerModalBoxStyle = ({
  zIndex = 3600,
  width = 920,
  maxWidth,
  maxHeight = '75vh',
  background = 'rgba(0,0,0,0.85)',
  border = '1.5px solid #107c6b',
  color = '#E7DFEC',
  position = 'fixed',
  centered = true
} = {}) => {
  const isMobileDevice =
    navigator.userAgentData?.mobile ??
    /Android.*Mobile|iPhone|iPod/i.test(navigator.userAgent)

  return {
    position,
    ...(centered
      ? {
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        }
      : {}),
    background,
    borderRadius: 12,
    padding: isMobileDevice ? 16 : 20,
    width: isMobileDevice ? 'calc(100vw - 32px)' : width,
    ...(isMobileDevice
      ? { maxWidth: 'calc(100vw - 32px)' }
      : maxWidth
        ? { maxWidth }
        : {}),
    boxSizing: isMobileDevice ? 'border-box' : undefined,
    maxHeight: isMobileDevice ? 'calc(100dvh - 32px)' : maxHeight,
    overflowY: 'auto',
    overflowX: isMobileDevice ? 'hidden' : undefined,
    overflowWrap: isMobileDevice ? 'anywhere' : undefined,
    fontSize: isMobileDevice ? 14 : undefined,
    lineHeight: isMobileDevice ? 1.45 : undefined,
    zIndex,
    border,
    boxShadow: '0 12px 28px rgba(0,0,0,0.65)',
    color
  }
}

export const footerModalTitleStyle = ({
  marginBottom = 8,
  fontSize = 24
} = {}) => ({
  marginBottom,
  fontWeight: 'bold',
  fontSize
})

export const footerModalActionsStyle = {
  display: 'flex',
  justifyContent: 'center',
  marginTop: 16
}